import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-relay-tooltip',
  templateUrl: './relay-tooltip.component.html',
  styleUrls: ['./relay-tooltip.component.scss'],
})
export class RelayTooltipComponent implements OnInit {
  @Input() vehicleId: string;
  @Input() position: any;
  @Input() data: any;

  constructor() {}

  ngOnInit(): void {}
}
